import styled from 'styled-components';

export const BadgeButtonBox = styled.div`
  button {
    color: rgba(33, 37, 41, 1);
    height: 38px;
    background: #fff;
    border: none;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
  }
`;

export const BadgeButtonCountBox = styled.div`
  background-color: #ff6a00;
  color: white;
  font-size: 12px;
  font-weight: 700;
  line-height: 9px;
  padding: 6px;
  border-radius: 11px;
`;
